import { render, staticRenderFns } from "./TagIconHoverNew.vue?vue&type=template&id=21f2e122"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f2e122')) {
      api.createRecord('21f2e122', component.options)
    } else {
      api.reload('21f2e122', component.options)
    }
    module.hot.accept("./TagIconHoverNew.vue?vue&type=template&id=21f2e122", function () {
      api.rerender('21f2e122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/TagIconHoverNew.vue"
export default component.exports